// SpoorthiDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import spoorthidoc from '../../../../assets/images/Doctorsimages/dr.spoothi_new.png'
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'


const SpoorthiDoc = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    document.title = "Dr. Spoorthi Prasad | Best Senior Homeopathy & Aesthetic Doctor in Jayanagar Bangalore";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Spoorthi Prasad (BHMS), Senior Consultant Homeopathy & Aesthetic Doctor at H-Cura Multispeciality Clinic, Jayanagar. Expert in holistic homeopathy, skin rejuvenation, anti-aging, and advanced hair restoration with 8+ years experience."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor in Jayanagar Bangalore, aesthetic doctor in Jayanagar, female homeopathy doctor Bangalore, senior consultant homeopathy doctor, skin rejuvenation Jayanagar, anti-aging treatments Bangalore, holistic doctor Jayanagar, homeopathy for PCOS, natural hair fall treatment, aesthetic skin clinic Jayanagar, PRP treatment Jayanagar, GFC hair treatment Bangalore"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-spoorthi-prasad-senior-homeopathy-doctor-jayanagar-bangalore";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
      img.style.display = 'block';
    });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        imageTimeout: 0
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;

        const pages = Math.ceil(imgHeight / pdfHeight);
        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.SPOORTHI_PRASAD_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 500);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Spoorthi Prasad</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Jayanagar, Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Senior Consultant <strong>Homeopathy & Aesthetic Doctor</strong> at H-Cura Multispeciality Clinic. With over 8 years of specialized experience, she is renowned for her dual expertise in constitutional homeopathy and advanced clinical aesthetics, offering a "Inside-Out" approach to health and beauty.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img 
                        src={spoorthidoc} 
                        alt="Dr. Spoorthi Prasad – Senior Homeopathy & Aesthetic Doctor" 
                        className="veenadoc-doctor-image" 
                        crossOrigin="anonymous"
                        title='Dr. Spoorthi Prasad | Best Homeopathy & Aesthetic Doctor in Jayanagar' 
                      />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Spoorthi Prasad</h2>
                  <p>
                    Dr. Spoorthi Prasad (BHMS) graduated from the prestigious <strong>Bhagavan Buddha Homoeopathic Medical College and Hospital, Bengaluru</strong>. Over the last 8 years, she has evolved her practice from classical homeopathy to an integrated model that includes <strong>Advanced Medical Aesthetics</strong>.
                  </p>
                  <p>
                    She believes that chronic skin and hair issues are often manifestations of internal health imbalances. Her mission is to provide patients in Jayanagar and Bangalore with treatments that are scientifically advanced yet naturally grounded.
                  </p>
                </div>

                {/* Specialized Treatments Section */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Treatments Offered</h2>
                  <p>Dr. Spoorthi provides a wide array of specialized treatments tailored to individual needs:</p>
                  
                  <h3 style={{marginTop: '20px', color: '#2e7d32'}}>1. Holistic Homeopathy</h3>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Constitutional Treatment:</strong> For chronic ailments like Asthma, Arthritis, and Migraines.</li>
                    <li><strong>Hormonal Balancing:</strong> Specialized protocols for PCOS, Thyroid disorders, and Infertility.</li>
                    <li><strong>Lifestyle Disorder Management:</strong> Natural solutions for Diabetes and Hypertension.</li>
                  </ul>

                  <h3 style={{marginTop: '20px', color: '#2e7d32'}}>2. Aesthetic Skin Care</h3>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Skin Rejuvenation:</strong> Chemical Peels, Carbon Laser Peel, and Medi-Facials.</li>
                    <li><strong>Pigmentation Therapy:</strong> Advanced treatments for Melasma, tanning, and uneven skin tone.</li>
                    <li><strong>Acne Management:</strong> Holistic acne control combined with scar revision therapies.</li>
                    <li><strong>Anti-Aging:</strong> Non-invasive therapies to improve skin elasticity and reduce fine lines.</li>
                  </ul>

                  <h3 style={{marginTop: '20px', color: '#2e7d32'}}>3. Advanced Trichology (Hair Care)</h3>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>PRP & GFC Therapy:</strong> Growth factor treatments for hair thinning and alopecia.</li>
                    <li><strong>Mesotherapy:</strong> Nutrient-rich scalp injections for hair regrowth.</li>
                    <li><strong>Laser Hair Therapy:</strong> Low-level laser treatments for scalp health.</li>
                  </ul>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS (Homeopathy)</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">8+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Expertise:</span>
                      <span className="veenadoc-info-value">Homeo-Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Clinic:</span>
                      <span className="veenadoc-info-value">H-Cura Jayanagar</span>
                    </div>
                  </div>
                </div>

                {/* Patient-Centric Approach */}
                <div className="veenadoc-article-block">
                  <h2>Why Choose Dr. Spoorthi?</h2>
                  <p>
                    Patients consistently choose Dr. Spoorthi for her <strong>thorough diagnostic process</strong>. She doesn't just treat the surface; she investigates emotional stress, nutritional deficiencies, and hormonal triggers. This ensures that when you receive an aesthetic treatment, it is supported by a solid foundation of internal health.
                  </p>
                  <p>
                    Her empathetic nature makes her a favorite among female patients seeking discreet and effective care for sensitive issues like PCOS-related acne or post-pregnancy hair loss.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Empowering Your Journey to Wellness</h2>
                  <p>
                    At H-Cura Multispeciality Clinic, Dr. Spoorthi Prasad is dedicated to transforming lives through the power of integrated medicine. Experience the future of healthcare where traditional wisdom meets modern aesthetic excellence.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To deliver visible aesthetic results supported by deep-rooted homeopathic healing for a healthier, more confident you.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{ fontSize: '1.1rem' }}>
                      "I treat the person in the disease, not just the disease in the person, while enhancing their natural beauty."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Spoorthi's Philosophy</p>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Treatments List</h3>
                  <ul className="veenadoc-services-list">
                    <li>🌿 Constitutional Homeopathy</li>
                    <li>✨ Chemical Peels & Medi-facials</li>
                    <li>💇‍♀️ PRP & GFC Hair Therapy</li>
                    <li>🦋 PCOS & Thyroid Care</li>
                    <li>🎯 Acne & Scar Revision</li>
                    <li>⏰ Non-Surgical Anti-Aging</li>
                  </ul>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Jayanagar</h4>
                      <p>9th Block, Jayanagar, Bangalore</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Take the first step toward holistic health and aesthetic perfection.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  )
}

export default SpoorthiDoc;
